module.exports = __webpack_public_path__ + "img/blm.71258370.png";